import React from 'react';
import {
  List,
  ListItemText,
  Typography,
  Checkbox,
  ListItemIcon,
} from '@mui/material';
import { IEntityCriteriaSimpleOperator } from '../../../../common/types/shared/entitySelection';
import { formatSimpleOperatorDisplayString } from '../helpers';
import { QueryableFieldsQuery } from '../../../../types/generated-types';
import ListItemButton from '@mui/material/ListItemButton';

interface SimpleOperatorListProps {
  operators: IEntityCriteriaSimpleOperator[];
  fieldsData: QueryableFieldsQuery['queryableFields'];
  onOperatorEdit: (operator: IEntityCriteriaSimpleOperator) => void;
  selectedOperators: Set<string>;
  onOperatorSelect: (operatorId: string) => void;
}

export const SimpleOperatorList: React.FC<SimpleOperatorListProps> = ({
  operators,
  fieldsData,
  onOperatorEdit,
  selectedOperators,
  onOperatorSelect,
}) => {
  return fieldsData ? (
    <List sx={{ padding: '0px', margin: '0px', overflow: 'auto' }}>
      {operators.map((operator) => (
        <ListItemButton
          key={operator.id}
          onClick={() => onOperatorEdit(operator)}
        >
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={selectedOperators.has(operator.id)}
              onClick={(e) => {
                e.stopPropagation();
                onOperatorSelect(operator.id);
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                component="pre"
                sx={{
                  fontFamily: 'inherit',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  margin: 0,
                }}
              >
                {formatSimpleOperatorDisplayString(operator, fieldsData)}
              </Typography>
            }
          />
        </ListItemButton>
      ))}
    </List>
  ) : (
    <div>Loading...</div>
  );
};
